export const formatColor = (color) => {
  if (!color) return false;
  if (!color.includes('#')) {
    return `#${color}`;
  }
  return color;
};
